import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="bg-[#E30022] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl lg:text-4xl font-serif">Mentions légales</h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 lg:p-12 prose prose-gray max-w-none">
          
          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">1. Éditeur du site</h2>
          <p className="text-gray-600 mb-4">
            <strong>Recrutement Suisse SA</strong><br/>
            Société anonyme de droit suisse<br/>
            Capital social : CHF 100'000.-<br/>
            Numéro IDE : CHE-000.000.000<br/>
            Inscrite au Registre du Commerce du Canton de Zurich
          </p>
          <p className="text-gray-600 mb-4">
            <strong>Siège social :</strong><br/>
            Limmatquai 112<br/>
            8001 Zürich<br/>
            Suisse
          </p>
          <p className="text-gray-600 mb-4">
            <strong>Contact :</strong><br/>
            Téléphone : +41 44 250 88 88<br/>
            Email : <a href="mailto:contact@recrutement-suisse.ch" className="text-[#E30022] hover:underline">contact@recrutement-suisse.ch</a>
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">2. Directeur de la publication</h2>
          <p className="text-gray-600 mb-4">
            Monsieur Pierre Müller, Directeur Général
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3. Hébergement</h2>
          <p className="text-gray-600 mb-4">
            Le site recrutement-suisse.ch est hébergé par :<br/>
            <strong>Infomaniak Network SA</strong><br/>
            Rue Eugène-Marziano 25<br/>
            1227 Les Acacias, Genève<br/>
            Suisse<br/>
            <a href="https://www.infomaniak.com" target="_blank" rel="noopener noreferrer" className="text-[#E30022] hover:underline">www.infomaniak.com</a>
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">4. Propriété intellectuelle</h2>
          <p className="text-gray-600 mb-4">
            L'ensemble du contenu du site recrutement-suisse.ch (textes, images, graphismes, logos, icônes, sons, logiciels, etc.) est la propriété exclusive de Recrutement Suisse SA ou de ses partenaires et est protégé par les lois suisses et internationales relatives à la propriété intellectuelle.
          </p>
          <p className="text-gray-600 mb-4">
            Toute reproduction, représentation, modification, publication, transmission, dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit est interdite sans l'autorisation écrite préalable de Recrutement Suisse SA.
          </p>
          <p className="text-gray-600 mb-4">
            Le nom "Recrutement Suisse" et le logo associé sont des marques déposées.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">5. Protection des données</h2>
          <p className="text-gray-600 mb-4">
            Conformément à la Loi fédérale sur la protection des données (LPD) et au Règlement général sur la protection des données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant.
          </p>
          <p className="text-gray-600 mb-4">
            Pour plus d'informations, consultez notre <a href="/politique-confidentialite" className="text-[#E30022] hover:underline">politique de confidentialité</a>.
          </p>
          <p className="text-gray-600 mb-4">
            <strong>Délégué à la protection des données :</strong><br/>
            Email : <a href="mailto:privacy@recrutement-suisse.ch" className="text-[#E30022] hover:underline">privacy@recrutement-suisse.ch</a>
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">6. Cookies</h2>
          <p className="text-gray-600 mb-4">
            Le site utilise des cookies pour améliorer l'expérience utilisateur. Pour gérer vos préférences, consultez nos <a href="/cookies" className="text-[#E30022] hover:underline">paramètres des cookies</a>.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">7. Liens hypertextes</h2>
          <p className="text-gray-600 mb-4">
            Le site peut contenir des liens vers d'autres sites internet. Recrutement Suisse SA n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou à leur politique de confidentialité.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">8. Droit applicable</h2>
          <p className="text-gray-600 mb-4">
            Les présentes mentions légales sont régies par le droit suisse. En cas de litige, les tribunaux du Canton de Zurich seront seuls compétents.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">9. Crédits</h2>
          <p className="text-gray-600 mb-4">
            <strong>Conception et développement :</strong> Recrutement Suisse SA<br/>
            <strong>Photographies :</strong> Unsplash, droits réservés
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
